export enum UnsignFlowStep {
  ShowChanges,
  SendInvitations,
  ChangeToVendorFlow,
  SelectNominatedVendor
}
